import React from 'react';

import Icon from '../../../../ui/Icon/Icon';
import Image from '../../../../ui/Image/Image';
import Text from '../../../../ui/Text/Text';

import useDeviceTypeDetector from '../../../../hooks/useDeviceTypeDetector/useDeviceTypeDetector';
import { IExpertProps } from './Expert.types';
import { useAccessibility } from '../../../../contexts/AccessibilityContext';
import { ThemeEnum } from '../../../../utils/enums';

const Expert: React.FC<IExpertProps> = ({ hint, img, name, skills, footNote }) => {
  const { isMobile, isTablet } = useDeviceTypeDetector();
  const {
    settings: { theme },
  } = useAccessibility();

  return (
    <div className='expert-item'>
      <div className='image'>
        <Image src={img.src} alt={img.alt} />
      </div>
      <div className='info'>
        {hint && (
          <Text variant='secondarySubtitle1' className='hint'>
            {hint}
          </Text>
        )}
        <Text variant='h3'>{name}</Text>
        {skills.length > 0 && (
          <ul className='skills-list'>
            {skills.map((skill) => (
              <li key={skill.id} className='skill-item'>
                <Icon
                  size={isMobile ? 16 : isTablet ? 24 : 32}
                  name={theme === ThemeEnum.Light ? 'arrowHeadRightLight' : 'arrowHeadRight'}
                />
                <Text variant='subtitle3'>{skill.text}</Text>
              </li>
            ))}
          </ul>
        )}
        {footNote && (
          <Text variant='subtitle4' className='foot-note'>
            {footNote}
          </Text>
        )}
      </div>
    </div>
  );
};

export default Expert;
